import { DropZone as DropZone$1 } from '@shopify/ui-extensions/checkout';
import { createRemoteReactComponent } from '@remote-ui/react';

const DropZone = createRemoteReactComponent(DropZone$1);

export { DropZone };
